import React from "react";
import MatarsounPage from "@components/Pages/MatarsounPage/MatarsounPage";

export default function Matarsoun() {
    return <MatarsounPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
